import * as Immutable from 'immutable'

export interface Config {
	isEnabled:boolean

	defaultCategoryId: number

	resultsDisplay: "paged" | "infiniteScrolling"
	resultsPerPage:number

	keywordsEnabled:boolean
	archiveEnabled:boolean
	categoriesEnabled:boolean
}

export interface OptionValue {
	getId():string;
	getLabel():string;
}

export interface PreferencesJson {
	person:number
	categoryIds:number[]
}

export class Preferences {
	constructor(
		private personId:number,
		private _categoryIds:Immutable.Set<number>) {}

	static fromObject(object:PreferencesJson):Preferences {
		return new Preferences(
			object.person,
			object.categoryIds == null ? Immutable.Set<number>() : Immutable.Set<number>(object.categoryIds)
		)
	}

	get categoryIds() { return this._categoryIds }

	isCategorySelected(category:Category):boolean {
		return this._categoryIds.has(category.getNumericId())
	}
}

export interface CategoryValue {
	categorySerial:number
	parentSerial:number
	title:string
	urlTitle:string
	thumbPath:string
	isLinked:boolean
}

export class Category implements CategoryValue, OptionValue {

	categorySerial:number=0
	parentSerial:number=0
	title:string=''
	urlTitle:string=''
	thumbPath:string=''
	isLinked:boolean = false

	children:Category[] = []

	private static PREFERRED_SERIAL:number = -1
	private static preferred:Category|null = null

	private static UNCATEGORISED_SERIAL:number = -2
	private static uncategorised:Category|null = null

	static get PREFERRED() {
		if (Category.preferred == null) {
			Category.preferred = new Category()
			Category.preferred.categorySerial = Category.PREFERRED_SERIAL
			Category.preferred.title = "My Preferences"
			Category.preferred.children = []
			Category.preferred.urlTitle = ""
			Category.preferred.thumbPath = ""
			Category.preferred.isLinked = false
		}
		return Category.preferred
	}

	static get UNCATEGORISED() {
		if (Category.uncategorised == null) {
			Category.uncategorised = new Category()
			Category.uncategorised.categorySerial = Category.UNCATEGORISED_SERIAL
			Category.uncategorised.title = "Uncategorised"
			Category.uncategorised.children = []
			Category.uncategorised.urlTitle = ""
			Category.uncategorised.thumbPath = ""
			Category.uncategorised.isLinked = false
		}
		return Category.uncategorised
	}

	isPreferredCategories():boolean { return this.categorySerial == Category.PREFERRED_SERIAL }

	getId():string { return this.categorySerial.toString(); }
	getLabel():string { return this.title; }

	static flattenTree(categories:Category[]) {
		const sideEffectingFlattener = (categories: Category[], flatteningCategories: Category[]) => categories.forEach(function(category) {
			flatteningCategories.push(category);
			sideEffectingFlattener(category.children, flatteningCategories);
		});

		const cats: Category[] = []
		sideEffectingFlattener(categories, cats)
		return cats
	}

	static fromObjects(objects:CategoryTreeJson[]) {
		return objects.map(function(object):Category {
			const category = new Category;
			category.categorySerial = +object.categorySerial;
			category.parentSerial = +object.parentSerial;
			category.title = ''+object.title;
			category.urlTitle = ''+object.urlTitle;
			category.thumbPath = ''+object.thumbPath;
			category.isLinked = !!object.isLinked;
			category.children = object.children === null ? [] : Category.fromObjects(object.children);
			return category;
		});
	}

	getNumericId():number {
		return this.categorySerial
	}
}

export interface CategoryTreeJson extends CategoryValue {
	children:CategoryTreeJson[]
}

/**
 * List of human readable strings that have no business logic associated with them.
 */
export interface ReadableLabels {
	category:string
}



// WEBPACK FOOTER //
// ./src/news2/advancedSearch/ValueObjects.ts